import axios from 'axios'

const public_document_form = {
  namespaced: true,
  state() {
    return {
      data: {
        document_name: null,
        outline: null,
        file_name: null,
        uuid: null,
      },
      errors: {},
    };
  },
  mutations: {
    setData(state, data) {
      state.data.document_name = data.document_name;
      state.data.outline = data.outline;
      state.data.file_name = data.file_name;
      state.data.uuid = data.uuid;
      state.errors = {};
    },
    resetData(state) {
      state.data.document_name = null;
      state.data.outline = null;
      state.data.file_name = null;
      state.errors = {};
    },
    setErrors(state, errors) {
      state.errors = { ...errors };
    },
    setError(state, payload) {
      state.errors[payload.key] = payload.value;
    },
    resetErrors(state) {
      state.errors = {};
    },
  },
  actions: {
    load({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/documents_management/${payload.id}`).then((response) => {
          commit('resetErrors');
          commit('setData', response.data.data);
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response && error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({ handled });
        });
      })
    },
    export({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`/api/documents_management/${payload.uuid}/download`).then((response) => {
          let base64 = response.data.data.file;
          let bin = atob(base64.replace(/^.*,/, ''));
          let buffer = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
          }
          const blob = new Blob([buffer.buffer], { type: response.data.data.content_type });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = response.data.data.file_name;
          link.click();
          window.URL.revokeObjectURL(link.href);
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response && error.response.status === 400) {
            commit('setError', { key: 'password', value: ['パスワードが正しくありません。'] });
            handled = true;
          }
          if (error.response && error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({ handled });
        });
      });
    },
  },
};

export default public_document_form;
